import React from 'react';
import { PhotoIcon, VideoIcon, ThreeDimensionalIcon } from '@domain-group/fe-co-icon';
import * as styles from './allhomes-listing-card-media-stats.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingCardMediaStats = _ref => {
  var className = _ref.className,
    _ref$numPhotos = _ref.numPhotos,
    numPhotos = _ref$numPhotos === void 0 ? 0 : _ref$numPhotos,
    _ref$has3dTour = _ref.has3dTour,
    has3dTour = _ref$has3dTour === void 0 ? false : _ref$has3dTour,
    _ref$hasVideo = _ref.hasVideo,
    hasVideo = _ref$hasVideo === void 0 ? false : _ref$hasVideo;
  return ___EmotionJSX("div", {
    css: styles.mediaStats,
    className: className
  }, (numPhotos !== null && numPhotos !== void 0 ? numPhotos : 0) > 0 && ___EmotionJSX("div", {
    css: styles.item
  }, ___EmotionJSX("span", {
    css: styles.itemIcon
  }, ___EmotionJSX(PhotoIcon, null)), ___EmotionJSX("span", {
    css: styles.itemValue
  }, numPhotos)), hasVideo && ___EmotionJSX("div", {
    css: styles.item
  }, ___EmotionJSX("span", {
    css: styles.itemIcon
  }, ___EmotionJSX(VideoIcon, null))), has3dTour && ___EmotionJSX("div", {
    css: styles.item
  }, ___EmotionJSX("span", {
    css: styles.itemIcon
  }, ___EmotionJSX(ThreeDimensionalIcon, null)), ___EmotionJSX("span", {
    css: styles.itemValue
  }, "3D")));
};
export default AllhomesListingCardMediaStats;